// extracted by mini-css-extract-plugin
export default {"pageWrap":"Vb-z","fullWidth":"Wb-z","heading":"Xb-z","fullBleed":"Yb-z","hidden":"Zb-z"};